import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class NominationsContainerSAS extends ShadowDOMElement {
	static className = "NominationsContainerSAS";
	
	static get properties() {
		return {
			membersRequired: { type: Boolean, attribute: 'members-required' }
		};
	}
	
	// Property to indicate if optional sections are required
	// By default false (président only is mandatory)
	membersRequired = false;
	
	render() {
    return html`
      <title-field label="Nominations"></title-field>
      <subtitle-field label="Ont été nommés"></subtitle-field>
      <subtitle-field label="Président"></subtitle-field>
      <personne-container representative="true"></personne-container>
      <checkbox-field
        label="Directeur général"
		id="chkDirecteurContainer"
        @change="${this.toggleVisibility.bind(this, 'directeur-container')}"
      ></checkbox-field>
      <personne-physique
        id="directeur-container"
        visible="false"
      ></personne-physique>
      <checkbox-field
        label="Membres d'un Comité de direction"
		id="chkComiteDirectionContainer"
        @change="${this.toggleVisibility.bind(this, 'comiteDirectionContainer')}"
      ></checkbox-field>
      <div-container id="comiteDirectionContainer" visible="false">
        <personne-physique-list></personne-physique-list>
      </div-container>
    `;
	}

	toggleVisibility (containerId, event) {
		const container = this.shadowRoot.querySelector(`#${containerId}`);
		if (container)
			container.visible = event.target.checked;

		// If the checkbox is checked, remove all existing validation messages
		if (event.target.checked) {
			this.shadowRoot.querySelectorAll('div[data-validation-for]').forEach(el => el.remove());
		}
	}
	
	isTransient (){
		return false;
	}
	
	#updateContainers (){
		const container1Visible = this.shadowRoot.querySelector("#chkDirecteurContainer").checked;
		const container2Visible = this.shadowRoot.querySelector("#chkComiteDirectionContainer").checked;
		
		this.shadowRoot.querySelector("#directeur-container").visible = container1Visible;
		this.shadowRoot.querySelector("#comiteDirectionContainer").visible = container2Visible;
	}
	
	setValues (values){
		super.setValues (values);
		this.#updateContainers ();
		this.requestUpdate ();
	}

	// Validation: show messages for each checkbox if none checked; return false in that case.
	validate() {
		// If 'membersRequired' property is false, no validation needed (président is always present)
		if (!this.membersRequired)
			return true;

		const checkboxes = this.shadowRoot.querySelectorAll('checkbox-field');

		// remove all existing validation messages first
		this.shadowRoot.querySelectorAll('div[data-validation-for]').forEach(el => el.remove());

		// if any checkbox is checked -> valid
		const anyChecked = Array.from(checkboxes).some(cb => !!cb.checked);
		if (anyChecked)
			return true;

		// none checked: show message for each checkbox and return false
		checkboxes.forEach(cb => {
			const id = cb.id || cb.getAttribute('id') || '';

			const row = document.createElement('div');
			row.className = 'row align-items-center';
			row.setAttribute('data-validation-for', id);

			const colLeft = document.createElement('div');
			colLeft.className = 'col-sm-3';

			const colRight = document.createElement('div');
			colRight.className = 'col-sm-9 text-danger d-flex align-items-center';
			colRight.style.paddingBottom = '0.25rem';
			colRight.style.paddingLeft = '0px';

			const icon = document.createElement('i');
			icon.className = 'fa-solid fa-circle-exclamation me-2';
			icon.setAttribute('aria-hidden', 'true');

			const text = document.createElement('span');
			text.textContent = 'Vous devez cocher au moins une modification';

			colRight.appendChild(icon);
			colRight.appendChild(text);

			row.appendChild(colLeft);
			row.appendChild(colRight);

			if (cb.parentNode) cb.parentNode.insertBefore(row, cb.nextSibling);
		});

		return false;
	}
}

customElements.define("nominations-container-sas", NominationsContainerSAS);
